// Vuex Client module mutations
import {
  FILL_USER_SESSION,
  FILL_ERROR_DATA,
  FILL_LOGIN_TOKEN,
} from './mutations-types';

export default {
  [FILL_USER_SESSION](state, payload) {
    state.userSession = payload;
  },
  [FILL_ERROR_DATA](state, payload) {
    state.errorData = payload;
  },
  [FILL_LOGIN_TOKEN](state, payload) {
    state.loginToken = payload.token;
  },
};
